import React from 'react';

export function FeatureBandRows({ rows }) {
  return (
    <div className="feature-band__rows">
      {rows.map((row) => (
        <article key={row.id} className="feature-band__row" aria-labelledby={row.headingId}>
          <div className="feature-band__media" aria-hidden="true">
            <img
              className="content-block__img"
              src={row.illustration}
              alt=""
              width={row.illustrationWidth}
              height={row.illustrationHeight}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="feature-band__copy">
            <h3 id={row.headingId} className="content-block__title">
              {row.title}
            </h3>
            <p className="content-block__lead">{row.lead}</p>
          </div>
          <ul className="feature-band__bullets">
            {row.bullets.map((bullet) => (
              <li key={bullet.text} className="feature-band__bullet">
                <span className="feature-band__bullet-icon" aria-hidden="true">
                  <img src={bullet.iconSrc} alt="" width={52} height={52} loading="lazy" decoding="async" />
                </span>
                <span className="content-block__detail feature-band__bullet-text">{bullet.text}</span>
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  );
}

const FeatureBand = ({
  sectionClassName,
  titleId,
  eyebrow,
  title,
  workflow = null,
  rows,
  cta,
}) => (
  <section className={`${sectionClassName} feature-band`} aria-labelledby={titleId}>
    <div className="page-container">
      <header className="section-panel__header section-panel__header--spaced">
        <p className="section-panel__eyebrow">{eyebrow}</p>
        <h2 id={titleId} className="section-panel__title">
          {title}
        </h2>
      </header>

      {workflow ? <div className="section-panel__workflow">{workflow}</div> : null}

      <FeatureBandRows rows={rows} />

      {cta ? <div className="section-panel__cta section-panel__cta--dual">{cta}</div> : null}
    </div>
  </section>
);

export default FeatureBand;
